import {
    CLEAR_NOTIFICATIONS,
    GET_NOTIFICATIONS,
    INCREASE_NOTIFICATION,
    LOAD_MORE_NOTIFICATIONS, READ_ALL_NOTIFICATIONS,
} from "../actions/types";

let initialState = {
    notifications: {
        current_page: null,
        data: [],
        first_page_url: null,
        from: null,
        last_page: null,
        last_page_url: null,
        links: [],
        next_page_url: null,
        path: null,
        per_page: null,
        prev_page_url: null,
        to: null,
        total: null,
    },
    counter: 0,
};

const notifications = (state = initialState, action) => {
    switch (action.type) {
        case GET_NOTIFICATIONS:
            return {...state, notifications: action.payload};
        case LOAD_MORE_NOTIFICATIONS:
            return {
                ...state,
                notifications: {
                    ...action.payload,
                    data: [...state?.notifications?.data, ...action.payload.data],
                },
            };
        case READ_ALL_NOTIFICATIONS :
            return {
                ...state,
                notifications: {
                    ...action.payload,
                    data: [
                        ...state?.notifications?.data.filter((val, key) => {
                            val['is_read'] = "1";
                            return val;
                        })
                    ],
                },
            }
        case INCREASE_NOTIFICATION:
            return {
                ...state,
                counter: state.counter + 1,
            };
        case CLEAR_NOTIFICATIONS:
            return initialState;
        default:
            return state;
    }
};

export default notifications;
